import { useFormContext } from 'react-hook-form'

import { FormControl, FormError, FormField, FormItem, FormLabel, Input, Textarea } from '@fortem-monorepo/react-ui'

import type { BalanceCorrectionValues } from './correction.schema'

export const BalanceCorrectionFormFields = ({ disabled }: { disabled: boolean }) => {
  const { control } = useFormContext<BalanceCorrectionValues>()
  return (
    <fieldset disabled={disabled} className="space-y-4">
      {(
        [
          ['opening_balance_local', 'Opening balance'],
          ['accrued_balance_local', 'Closing balance'],
        ] as const
      ).map(([name, label]) => (
        <FormField
          key={name}
          control={control}
          name={name}
          render={({ field }) => (
            <FormItem>
              <div className="flex items-center gap-2">
                <FormLabel>{label}</FormLabel>
                <FormError />
              </div>
              <FormControl>
                <Input inputSize="sm" inputMode="decimal" {...field} />
              </FormControl>
            </FormItem>
          )}
        />
      ))}
      <FormField
        control={control}
        name="notes"
        render={({ field }) => (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Reason (11–200 characters)</FormLabel>
              <FormError />
            </div>
            <FormControl>
              <Textarea maxLength={200} {...field} />
            </FormControl>
          </FormItem>
        )}
      />
    </fieldset>
  )
}
